import pulseLocations from '~lib/common/config/pulseLocations';
import withProps from '~lib/common/hoc/withProps'

import CasePulse from './CasePulse';

export default withProps({
    pulseLocations
})(CasePulse);
